import React, { useState } from 'react';
import Logo from '../../assets/imgs/logo_mig.png'

import { useNavigate } from 'react-router-dom'

export default function NavbarAdmin(params) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const nav = useNavigate()

  const handleNav = (destino) => {
    nav(destino)
  }

  return (
    <div className='bg-primary top-0 h-28 flex items-center'>
      <div className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
        <nav className='flex justify-between items-center'>
          <span onClick={() => handleNav("/relatos")} className='hover:cursor-pointer'>
            <img src={Logo} alt="Migplus" />
          </span>
          <section className='flex lg:hidden'>
            <div className='space-y-2' onClick={() => setIsMenuOpen((prev) => !prev)}>
              <span className="block h-0.5 w-8 bg-white"></span>
              <span className="block h-0.5 w-8 bg-white"></span>
              <span className="block h-0.5 w-8 bg-white"></span>
            </div>
            <div className={isMenuOpen ? "flex absolute w-full top-28 left-0 bg-primary z-10 flex-col justify-around items-center animate-slide-down" : "hidden"}>
              <ul className='gap-8 text-white uppercase flex flex-col items-center m-8 '>
                <li >
                  <span onClick={() => handleNav("/relatos")}>Relatos</span>
                </li>
                <li >
                  <a href="/">sair</a>
                </li>
              </ul>
            </div>
          </section>
          <ul className='gap-4 text-white uppercase hidden lg:flex'>
            <li className='hover:underline cursor-pointer'>
              <span onClick={() => handleNav("/relatos")}>Relatos</span>
            </li>
            <li className='hover:underline cursor-pointer'>
              <a href="/">sair</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  )
};
